import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./wholesaleProgram.gql"

export const useWholesaleProgramPage = (props) => {
  const {
    afterSubmit 
  } = props

  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    addWholeSaleMutation 
  } = operations

  const formApiRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)

  const [addWholeSaleInfo, {
    data, error: addWholeSaleError 
  }] = useMutation(
    addWholeSaleMutation,
    {
      fetchPolicy: "no-cache",
    }
  )

  const handleSubmit = useCallback(
    async (formValues) => {
      setIsLoading(true)

      if (!formValues.hasOwnProperty("remark")) {
        formValues.remark = ""
      }

      formValues.interested = formValues.interested.join(",")

      try {
        await addWholeSaleInfo({
          variables: formValues,
        })

        formApiRef.current.resetFields()

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        console.error(error)

        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addWholeSaleInfo, afterSubmit, formApiRef]
  )

  const errors = useMemo(() => {
    if (addWholeSaleError) {
      return [addWholeSaleError]
    } else if (data?.addWholesaleProgram?.code === "500") {
      return [new Error(data.addWholesaleProgram.content)]
    }
 
    return []
        
  }, [data, addWholeSaleError])

  return {
    formApiRef,
    isLoading,
    formErrors: errors,
    handleSubmit,
    response: data && data.addWholesaleProgram,
  }
}
